import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import PrimaryButton from '../common/PrimaryButton';
import RegularButton from '../common/RegularButton';
import i18n from '../../helpers/I18nJs';

const styles = theme => ({
  dialogTitle: {
    padding: `${theme.spacing(2.5)} ${theme.spacing(3)}`,
  },
  dialogTitleText: {
    fontSize: '1.125rem',
    fontWeight: 600,
  },
  dialogContent: {
    padding: `${theme.spacing(2.5)} ${theme.spacing(3)}`,
    fontSize: '1rem',
  },
  dialogActions: {
    padding: `${theme.spacing(2.5)} ${theme.spacing(3)}`,
  },
});

const CreateOrganizationConfirmationModal = ({ classes, open, onClose }) => (
  <Dialog
    open={open}
    fullWidth
    maxWidth="sm"
  >
    <DialogTitle className={classes.dialogTitle}>
      <Typography className={classes.dialogTitleText}>
        {i18n.t('js.sign_up.organization.confirmation_modal.title')}
      </Typography>
    </DialogTitle>
    <DialogContent className={classes.dialogContent} dividers>
      <Typography>
        {i18n.t('js.sign_up.organization.confirmation_modal.description')}
        {' '}
        <Link href="mailto:support@rakuna.co">support@rakuna.co</Link>
        .
      </Typography>
      <Typography style={{ marginTop: '16px' }}>
        {i18n.t('js.sign_up.organization.confirmation_modal.confirm_text')}
      </Typography>
    </DialogContent>
    <DialogActions className={classes.dialogActions}>
      <Grid container spacing={3} justifyContent="flex-end">
        <Grid item xs={3}>
          <RegularButton
            text={i18n.t('js.sign_in.form.button.sign_in')}
            onClick={() => { window.location.href = '/recruiter/sign_in'; }}
          />
        </Grid>
        <Grid item xs={3}>
          <PrimaryButton
            text={i18n.t('js.common.button.confirm')}
            onClick={onClose}
          />
        </Grid>
      </Grid>
    </DialogActions>
  </Dialog>
);

CreateOrganizationConfirmationModal.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(CreateOrganizationConfirmationModal);
